module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h1', {
    staticClass: "greeting"
  }, [_vm._v("Hello " + _vm._s(_vm.localUser) + " !!")]), _vm._v(" "), _c('span', {
    staticClass: "sub",
    on: {
      "click": _vm.toggleUserInput
    }
  }, [_vm._v("Not you?")]), _vm._v(" "), (_vm.showUserInput) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localUser),
      expression: "localUser"
    }],
    ref: "inputUser",
    attrs: {
      "placeholder": "Insert your name"
    },
    domProps: {
      "value": _vm._s(_vm.localUser)
    },
    on: {
      "keyup": [_vm.changeUser, function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.closeUser($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localUser = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showUserInput) ? _c('span', {
    on: {
      "click": _vm.closeUser
    }
  }, [_vm._v(" close")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('h3', [_vm._v(" Add new problems to solve (: ")]), _vm._v(" "), _c('h4', {
    staticClass: "warning"
  }, [_vm._v(" " + _vm._s(_vm.message) + " ")]), _vm._v(" "), _c('problem-form', {
    ref: "problemForm",
    attrs: {
      "newProblem": _vm.newProblem,
      "problems": _vm.problems,
      "toEdit": _vm.toEdit
    },
    on: {
      "addProblem": _vm.addProblem,
      "doneEdit": _vm.doneEdit
    }
  }), _vm._v(" "), _c('problem-list', {
    attrs: {
      "problems": _vm.problems
    },
    on: {
      "editProblem": _vm.editProblem,
      "removeProblem": _vm.removeProblem
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4846e4ad!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 52
// module chunks = 2